module.exports = new __parcel__URL__("shop_buy_button.0b1939fe.png").toString();